import type { EChartsCoreOption } from 'echarts/core';

type GetYAxisOptionsReturnType = EChartsCoreOption['yAxis'];

export const getYAxisOptions = (): GetYAxisOptionsReturnType => {
  return [
    {
      type: 'value',
      show: false,
      min: 'dataMin',
    },
    {
      type: 'value',
      show: false,
      min: 0,
    },
  ];
};
